if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.isManuallySelecting = false;
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          prevButton: this.querySelector('.media-gallery-button .slider-button--prev'),
          nextButton: this.querySelector('.media-gallery-button .slider-button--next'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', (event) => {
          if (this.isManuallySelecting) {
            this.isManuallySelecting = false;
            return;
          }
          this.onSlideChanged(event);
        });
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button').addEventListener('click', () => {
            this.isManuallySelecting = true;  
            this.setActiveMedia(mediaToSwitch.dataset.target, false);
          });
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

        // Add event listeners for the new buttons
        this.elements.prevButton?.addEventListener('click', this.showPreviousSlide.bind(this));
        this.elements.nextButton?.addEventListener('click', this.showNextSlide.bind(this));

        this.updateButtonState();
      }

      showPreviousSlide() {
        const currentActive = this.elements.viewer.querySelector('.is-active');
        const previousMedia = currentActive.previousElementSibling;
        if (previousMedia) {
          this.setActiveMedia(previousMedia.dataset.mediaId, false);
        }
        this.updateButtonState();
      }

      showNextSlide() {
        const currentActive = this.elements.viewer.querySelector('.is-active');
        const nextMedia = currentActive.nextElementSibling;
        if (nextMedia) {
          this.setActiveMedia(nextMedia.dataset.mediaId, false);
        }
        this.updateButtonState();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail,'onSlideChanged');
        this.updateButtonState(); // Update button state on slide change
      }

      updateButtonState() {
        const currentActive = this.elements.viewer.querySelector('.is-active');
        if (this.elements.prevButton) {
          this.elements.prevButton.disabled = !currentActive.previousElementSibling;
        }

        if (this.elements.nextButton) {
          this.elements.nextButton.disabled = !currentActive.nextElementSibling;
        }
      }
      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail,'setActiveMedia');
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        this.updateButtonState();
      }

      setActiveThumbnail(thumbnail,type) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        const left = thumbnail.offsetLeft;
        const thumbnailsWidth = this.elements.thumbnails.offsetWidth;
        const slider = this.elements.thumbnails.querySelector('[id^="Slider-Thumbnails"]');
        if (left > thumbnailsWidth / 2) {
          slider.scrollTo({ left: left - thumbnailsWidth / 2, behavior: 'smooth' });
        } else {
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
  customElements.define('custom-cursor', class CustomCursor extends HTMLElement {
    constructor() {
      super();
      this.galleryParent = this.closest('media-gallery');
      this.viewer = this.galleryParent?.elements?.viewer;
      this.isOverMediaIcon = false;
      this.isDesktop = window.innerWidth >= 750;
      this.setup();
    }

    setup() {
      if (!this.galleryParent || !this.viewer) return;
      const { clientWidth: cursorWidth, clientHeight: cursorHeight } = this;
      Object.assign(this, { cursorWidth, cursorHeight });

      const events = [
        ['mousemove', this.onMouseMove],
        ['mouseleave', this.onMouseLeave],
        ['mouseenter', this.onMouseEnter],
        ['click', this.onClick]
      ];
      events.forEach(([e, fn]) => this.viewer.addEventListener(e, fn.bind(this)));

      this.checkInitialMousePosition();
    }

    checkInitialMousePosition() {
      // 确保光标初始状态为隐藏
      this.toggleCursorVisibility(false);
      
      // 延迟检查以确保页面元素已完全渲染和滚动完成
      setTimeout(() => {
        const rect = this.viewer.getBoundingClientRect();
        
        // 确保viewer元素已正确渲染（有实际尺寸）
        if (rect.width === 0 || rect.height === 0) {
          // 如果元素尺寸为0，等待下一帧再检查
          setTimeout(() => this.checkInitialMousePosition(), 100);
          return;
        }

        const inBounds = (x, y) =>
          x >= rect.left && x <= rect.right &&
          y >= rect.top && y <= rect.bottom;

        // 设置鼠标移动监听器，只有在用户真正移动鼠标时才显示光标
        const checkMouse = (e) => {
          const currentRect = this.viewer.getBoundingClientRect();
          const currentInBounds = (x, y) =>
            x >= currentRect.left && x <= currentRect.right &&
            y >= currentRect.top && y <= currentRect.bottom;
          
          if (currentInBounds(e.clientX, e.clientY)) {
            this.onMouseEnter();
            this.onMouseMove(e);
          }
          document.removeEventListener('mousemove', checkMouse);
        };
        document.addEventListener('mousemove', checkMouse, { once: true });
      }, 0); // 增加延迟时间，确保页面滚动完成
    }

    onClick(event) {
      if (this.isOverMediaIcon || !this.isDesktop) return;
      const direction = this.classList.contains('cursor-right') ? 'next' : 'prev';
      this.galleryParent.elements[`${direction}Button`]?.click();
    }

    onMouseMove(event) {
      const rect = this.viewer.getBoundingClientRect();
      const { clientX, clientY } = event;
      const x = clientX - rect.left - this.cursorWidth / 2;
      const y = clientY - rect.top - this.cursorHeight / 2;

      const isCurrentlyOverMediaIcon = !!document
        .elementFromPoint(clientX, clientY)
        ?.closest('.product__media-icon');

      if (isCurrentlyOverMediaIcon !== this.isOverMediaIcon) {
        this.isOverMediaIcon = isCurrentlyOverMediaIcon;
        this.toggleCursorVisibility(!isCurrentlyOverMediaIcon);
      }

      if (!this.isOverMediaIcon) {
        this.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        const isLeft = x < rect.width / 2;
        this.classList.toggle('cursor-left', isLeft);
        this.classList.toggle('cursor-right', !isLeft);
      }
    }

    toggleCursorVisibility(visible) {
      this.style.visibility = visible ? 'visible' : 'hidden';
      this.viewer.style.cursor = visible ? 'none' : '';
    }

    onMouseLeave() {
      this.toggleCursorVisibility(false);
    }

    onMouseEnter() {
      this.toggleCursorVisibility(true);
    }
  });
}
